import logo from '../../assets/codikett.png'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useKeycloak } from '@react-keycloak/web';
import { isAuthorized } from '../../js/globalFunctions';


function SECHeader({handleCreate}) {
    const {keycloak} = useKeycloak()
    const isCreateAuthorized = isAuthorized(keycloak, 'react_page_create', 'service-core');

    return (
      <header className="app-header">
        <img src={logo} />
        <div className="main--header--title--actions--option">
            {isCreateAuthorized && <AddCircleIcon id="create" data-tour="create-step" color="action" onClick={() => handleCreate(true)} />}
        </div>

      </header>
    )
}

export default SECHeader;